var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12150_93625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.60449C5.91544 2.60449 2.60422 5.91572 2.60422 10.0003C2.60422 14.0849 5.91544 17.3962 10 17.3962C14.0847 17.3962 17.3959 14.0849 17.3959 10.0003C17.3959 5.91572 14.0847 2.60449 10 2.60449ZM0.729218 10.0003C0.729218 4.88019 4.87991 0.729492 10 0.729492C15.1202 0.729492 19.2709 4.88019 19.2709 10.0003C19.2709 15.1205 15.1202 19.2712 10 19.2712C4.87991 19.2712 0.729218 15.1205 0.729218 10.0003ZM13.1629 6.8374C13.529 7.20352 13.529 7.79711 13.1629 8.16322L11.3258 10.0003L13.1629 11.8374C13.529 12.2035 13.529 12.7971 13.1629 13.1632C12.7968 13.5293 12.2032 13.5293 11.8371 13.1632L10 11.3261L8.16291 13.1632C7.7968 13.5293 7.2032 13.5293 6.83709 13.1632C6.47097 12.7971 6.47097 12.2035 6.83709 11.8374L8.67417 10.0003L6.83709 8.16322C6.47097 7.79711 6.47097 7.20352 6.83709 6.8374C7.2032 6.47128 7.7968 6.47128 8.16291 6.8374L10 8.67449L11.8371 6.8374C12.2032 6.47128 12.7968 6.47128 13.1629 6.8374Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12150_93625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCircle);
export default __webpack_public_path__ + "static/media/x-circle.488081f60b302d6a60ade8c107c4a977.svg";
export { ForwardRef as ReactComponent };